export const EntitiesProperties = {
    NOT_NUMERIC: {
        NAME: "name",
        PLATFORM: "platform",
        PAYMENT: "payment",
        ID_UNDERSCORE: "_id",
        MODIFY_DATE: "modifiedDate",
        CREATED_DATE: "createdDate",
        PUBLISHED_DATE: "publishedDate",
        IS_DISPLAY_AS_FREE: "isDisplayableAsFree",
        NAME_UPERCASE: "Name",
        PLATFORM_UPERCASE: "Platform",
        PAYMENT_UPERCASE: "Payment",
    },
    // Numeric values.
    NUMERIC: {
        // Can sum them.
        ADDABLE: {
            // Lowercase values.
            IMPRESSIONS: "impressions",
            REQUESTS: "requests",
            OPPORTUNITIES: "opportunities",
            REVENUE: "revenue",
            COST: "cost",
            PROFIT: "profit",
            RATINGS: "ratings",

            // Upercase values.
            REVENUE_UPERCASE: "Revenue",
            OPPORTUNITIES_UPERCASE: "Opportunities",
            IMPRESSIONS_UPERCASE: "Impressions",
            REQUESTS_UPERCASE: "Requests",
            COST_UPPERCASE: "Cost",
            PROFIT_UPPERCASE: "Profit",
        },
        // All the numeric keys.
        ALL: {
            // Lowercase values.
            IMPRESSIONS: "impressions",
            REQUESTS: "requests",
            OPPORTUNITIES: "opportunities",
            REVENUE: "revenue",
            FILL: "fill",
            FILL_RATE: "fillRate",
            FILL_RATE_BEACHFRONT_STYLE: "fillRate",
            REVENUE_PRECENT: "revenuePercent",
            CPM: "cpm",
            CTR: "ctr",
            VCR: "vcr",
            COST: "cost",
            PROFIT: "profit",
            RATINGS: "ratings",
            PROFIT_PERCENT:'profitPercent'
        },
    },
};

export const GRAPHS = {
    TYPES: {
        ACCUMULATE: "accumulate",
        DELTA: "delta",
    },

};

